import Drawer from '@mui/material/Drawer';
import styled, { css } from 'styled-components';
import { Button } from '../../../../components/Button';
import { Checkbox } from '../../../../components/Checkbox';
import { Input } from '../../../../components/Input';
import { PageTitle } from '../../../../components/PageTitle';
import { Select } from '../../../../components/Select';
import { colors } from '../../../../constants/Colors';
import { FontWeight } from '../../../../constants/Styles/fontWeight';
import { typography } from '../../../../helpers/styles/typography';
import { units } from '../../../../helpers/styles/units';
import chevron from '../../../../styles/images/filter-products/dropdown.svg';
import { SelectProps } from '../../../../types/Select/SelectProps';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${units(20)};
  width: ${units(322)};
  padding-left: ${units(12)};
  margin-bottom: ${units((72 + 96) / 2)};
`;

export const StyledPageTitle = styled(PageTitle)`
  font-weight: ${FontWeight.MEDIUM};
  margin-bottom: 0;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(8)};
`;

export const StyledInput = styled(Input)`
  font-weight: ${FontWeight.REGULAR};
  letter-spacing: 0.8px;
  width: 100%;

  background-color: ${colors.white};

  ${typography(10)};

  & ::-webkit-calendar-picker-indicator {
    color: transparent;
    background: none;
    z-index: 1;
  }
`;

export const Subtitle = styled.div`
  font-weight: ${FontWeight.MEDIUM};
  ${typography(10)};
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(12)};
`;

export const CategoriesWrapper = styled.div`
    position: relative;
  display: flex;
  flex-direction: column;
  gap: ${units(6)};
`;

export const SettingsButton = styled(Button)<{color?: string}>`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: ${units(4)};
    width: 100%;
    height: ${units(24)};
    font-weight: ${FontWeight.MEDIUM};
`;

export const ButtonsWrapper = styled.div`
  padding: ${units(12)};
  width: calc(100% - ${units(124)});
  background-color: ${colors.light};
  border-top: 1px solid ${colors.grey40};
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
`;

export const DrawerButtonsWrapper = styled(ButtonsWrapper)`
  padding: ${units(12)} ${units(27)};
  width: ${units(337)};
`;

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: ${units(8)};
  width: ${units(310)};
`;

export const DrawerButtonsContainer = styled(ButtonsContainer)`
  width: 100%;
`;

export const StyledDrawer = styled(Drawer)`
  & .MuiPaper-root {
    width: ${units(337)};
    padding: ${units(27)};
    box-shadow: none;
  }

  & .MuiBackdrop-root.MuiModal-backdrop {
    background: ${colors.grey10};
    opacity: 0.4 !important;
  }
`;

export const DrawerRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(20)};
  margin-bottom: ${units(50)};
`;

export const DrawerHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.div`
  font-weight: ${FontWeight.MEDIUM};
  letter-spacing: 1px;

  ${typography(20)};
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  &:hover svg {
    filter: brightness(0) saturate(100%) invert(75%) sepia(76%) saturate(6644%)
    hue-rotate(332deg) brightness(91%) contrast(98%);
  }

  &:active svg {
    filter: brightness(0) saturate(100%) invert(31%) sepia(43%) saturate(1816%)
    hue-rotate(333deg) brightness(96%) contrast(89%);
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${units(3)};
  //max-width: ${units(137)};
  width: 100%;
  height: ${units(24)};
`;

export const StyledCheckbox = styled(Checkbox)`
    .titleCheckbox[disabled] {
        &:before {
            background-color: ${colors.grayscale100};
        }
    }
`;

export const StyledSelect = styled(Select) <Pick<SelectProps, 'disabled'>>`
    ${({ disabled }) => css`
        position: relative;
        padding: ${units(4)};
        border: none;
        
        background-color: ${disabled ? colors.grayscale02 : colors.grayscale01};
        width: ${units(114)};
        height: ${units(17)};
            
        div[disabled] {
            background-color: transparent !important;
        }
        
        & > div > div {
            border-bottom: none;
        }
    
        .label {
          color: ${colors.greyDark};
          ${typography(5)};
          user-select: none;
        }
        
        .selectHeader {
            padding: 0;
            background-color: transparent;
            border-bottom: none;
        }
    
        p {
            user-select: none;
            ${typography(5)};
        }
        
        .options {
            width: ${units(114)};
            position: absolute;
            top: ${units(13)};
            left: ${units(-4)};
            border: none;
            border-radius: 0;
            
            div:hover {
                background-color: ${colors.grayscale02};
                user-select: none;
            }
        }
        
        svg {
            display: none;
        }
        
        &:before {
            content: '';
            position: absolute;
            z-index: 1;
            top: 50%;
            right: ${units(4)};
            transform: translateY(-50%);
            width: ${units(4.5)};
            height: ${units(5)};
            background-size: ${units(4.5)} ${units(5)};
            background-image: url(${chevron});
        }
    `}
    }
`;

export const ErrorWrapper = styled.div`
  position: absolute;
  bottom: ${units(-12)};
  left: ${units(0)};
  z-index: 6;
  display: flex;
  color: ${colors.red};
  ${typography(5)};
`;
